import { ApiError, fetchWithAuth } from "@entities/user-tokens";

import type { GenerationTask } from "../GenerationTask";
import type { GenerationResult } from "../GenerationResult";

type GetTaskResponse = {
    task: GenerationTask & {
        result?: GenerationResult;
    };
};

export async function getTask(projectId: string, taskId: string): Promise<GetTaskResponse["task"]> {
    const res = await fetchWithAuth(
        `/generation-tasks/${encodeURIComponent(taskId)}?projectId=${encodeURIComponent(projectId)}`,
        { method: "GET", headers: { Accept: "application/json" } }
    );
    if (!res.ok) {
        throw await ApiError.fromResponse(res, "生成タスクの取得に失敗しました");
    }
    const body = (await res.json()) as GetTaskResponse;
    return body.task;
}
